import { colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import React from "react";
import styled from "styled-components";

interface Props {
    text: string;
}

const Item = styled.li`
    font-size: ${rem(18)};
    line-height: 1.33em;
    color: ${colours.darkBlue};
    @media (min-width: ${breakpointWidth("lg")}) {
        font-size: ${rem(22)};
    }
`;

const OrderStepIncomplete = ({ text }: Props) => {
    return <Item>{text}</Item>;
};

export default OrderStepIncomplete;
